import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import { useTranslation  } from 'react-i18next';
import classNames from 'classnames'

const SideBar = props => {
	const { t } = useTranslation();
	const pathName = useLocation().pathname;

	return(
		<div className="sidebar">
			<div className="admin_id">Admin</div>
			<div className="nav">
				{props.submenus.map((item, index) => (
					<Link to={item.path} key={index}>
						<div className={classNames(item.className, {'on': (pathName === item.path ? true : false)})} id={index}>
							{t(item.menu)}
						</div>
					</Link>
				))}
			</div>
		</div>
	)
}

export default SideBar